import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlReceitaDiaria = '/service/contabilidade/transparencia/receita/'

class ReceitaDiariaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            dataInicial: filtro.dataInicial ? moment(filtro.dataInicial).format() : null,
            dataFinal: filtro.dataFinal ? moment(filtro.dataFinal).format() : null,
            administracao: filtro.administracao && filtro.administracao ? filtro.administracao : this.state.adms,
            codigoRecurso: filtro.codigoRecurso ? filtro.codigoRecurso : null,
            codigoDestinacao: filtro.codigoDestinacao ? filtro.codigoDestinacao : null,
            grau: filtro.grau ? filtro.grau : null,
            codigoReceita: filtro.codigoReceita ? filtro.codigoReceita : null,
        }
        return this.conex.post(urlReceitaDiaria + 'consultaReceitaDiaria/', JSON.stringify(data))
    }
}

export default ReceitaDiariaService
